import styles from './styles.module.scss'

export const Loader = () => (
  <center>
    <div aria-label="loading" className={styles.loader} />
  </center>
)
